import {useEffect, useState} from "react";
import {stopModelData} from "../services/ModelService";
import {keyBy, values} from "lodash";

export default function useAllStops() {
    const [allStops, setAllStops] = useState(null);
    const [allDepots, setAllDepots] = useState(null);
    const [allRestrictedPoints, setAllRestrictedPoints] = useState(null);
    const [allStopsByStopCode, setAllStopsByStopCode] = useState(null);

    useEffect(() => {
        const loadStops = async () => {
            try {
                const stops = await stopModelData.getAll();
                values(stops).forEach(stop => {
                    stop.stopCode = String(stop.stopCode);
                });
                setAllStops(stops);
            } catch (error) {
                console.error('Error loading stops:', error);
            }
        };

        loadStops();
    }, []);

    useEffect(() => {
        if (allStops) {
            setAllDepots(keyBy(values(allStops).filter(stop => stop.stopType === 'depot'), 'stopId'));
            setAllRestrictedPoints(values(allStops).filter(stop => stop.stopType === 'restricted'));
            setAllStopsByStopCode(keyBy(values(allStops), 'stopCode'));
        }
    }, [allStops, setAllDepots, setAllRestrictedPoints]);

    return {
        setAllStops,
        allStops,
        allDepots,
        allRestrictedPoints,
        allStopsByStopCode
    };
}

